/**
 * Printable pages types
 *
 * @export
 * @enum {string}
 */
export enum PrintablePages {
   ComparisonSheet = 'ComparisonSheet'
}
